import { render, staticRenderFns } from "./JsonTree.vue?vue&type=template&id=1f84e172"
import script from "./JsonTree.vue?vue&type=script&lang=js"
export * from "./JsonTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports